import(/* webpackMode: "eager" */ "/tmp/8df0f14649f80a1/app/[locale]/error.tsx");
